import React, { useEffect, useState } from "react";
import axios from "axios";

import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import Notification from "../../../elements/notification/Notification";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import MaterialPagination from "../../../styles/materialPagination";
import ClientConnectionsList from "./ClientConnectionsList";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import { removeTransferFromCollection } from "../../../../utils/collections";
import ProjectConnectionsFilter from "./ProjectFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

const ClientConnectionsContainer = ({ match }) => {

  const [connections, setConnections] = useState();
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "connections", false, true),
    "service.name": checkFilterItem(history, "service.name", null),
    "id": checkFilterItem(history, "id", null),
    "createDate[gte]": checkFilterItem(history, "createDate[gte]", null, true),
    "createDate[lte]": checkFilterItem(history, "createDate[lte]", null, true),
    "enablePayment": checkFilterItem(history, "enablePayment", null),
    "enablePayout": checkFilterItem(history, "enablePayout", null)

  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchConnections = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/connections" + filterUrl + "&project.user.id=" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setConnections(removeTransferFromCollection(response.data["hydra:member"]));
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchConnections();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="content-head">
        <ProjectConnectionsFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <ClientConnectionsList
        connections={connections}
        fetchConnections={fetchConnections}
        notification={notification}
        setNotification={setNotification}
      />
      {totalPageCount > 1  &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
    </>
  );
};

export default ClientConnectionsContainer;